import { createSlice } from '@reduxjs/toolkit';
import { ListViewOption } from 'core/components/listToggle/listToggleControl';
import { WipFilterModel } from 'core/models/WipFilterModel';
import { logger } from 'utils/logger';
import * as styleService from 'services/styleService';
import { MediaFilterModel } from 'core/models';
import ResultSet from 'core/models/ResultSet';


const distributionSlice = createSlice({
  name: 'distributionSlice',
  initialState: {
    wips: new ResultSet(),
    selectedWip: null,
    selectedStyles: [],
    displayPrefs: { mediaDisplayType: ListViewOption.GRID },
    // The list's column choices (column id -> shown); null means the
    // column defaults (meta.show).
    listColumns: null,
    wipFilter: { ...new WipFilterModel(),groupBy:'dept'},
    styleFilter: { ...new WipFilterModel()},
    styleMediaFilter: { ...new MediaFilterModel()},
    styles: new ResultSet(),
    selectedStyle:null,
    // standard props
    error: null,
    success: null,
    loading: false,
    action: null,
  },
  reducers: {
    setListColumns(state, action) {
      state.listColumns = action.payload ? { ...action.payload } : null;
    },
    setDisplayPrefs(state, action) {
      state.displayPrefs = { ...action.payload };
    },
    selectStyle(state, action) {
      logger.log('Setting Style: ', action.payload);
      state.selectedStyle = action.payload ? { ...action.payload } : null;
    },
    selectStyles(state, action) {
      logger.log('setting selected wips', action.payload);
      state.selectedStyles = action.payload ? [...action.payload] : [];
    },
    setWipFilter(state, action) {
      logger.log('Setting Wip: ', action.payload);
      state.wipFilter = action.payload ? { ...action.payload } : null;
    },
    setStyleFilter(state, action) {
      logger.log('Setting Style Filter: ', action.payload);
      state.styleFilter = action.payload ? { ...action.payload } : null;
    },
    setStyleMediaFilter(state, action) {
      logger.log('Setting Style Filter: ', action.payload);
      state.styleMediaFilter = action.payload ? { ...action.payload } : null;
    },

    setError(state, action){
      state.error = action.payload;
    },
    //////////////////////
    //
    // GET STYLES
    //
    //////////////////////
    getWipsStart(state, action) {
      state.success = null;
      state.error = null;
    },
    getWipsSuccess(state, action) {
      logger.log('getWipSuccess : SUCCESS');

      state.loading = false;
      state.success = { type: action.type, message: 'Get Wips Success' };

      state.wips = {
        ...state.wips,
        [action.payload.id]: {
          data: action.payload.data,
          timestamp: action.payload.timestamp
        }
      };
      //state.openIssuesCount = action.payload.open_issues_count
      state.error = null;
    },
    getWipsFailure(state, action) {
      logger.log(state, action, 'fail');
      state.error = action.payload;
    },
    

    //////////////////////
    //
    // GET STYLES
    //
    //////////////////////
    getStylesStart(state, action) {
      state.success = null;
      state.error = null;
    },
    getStylesSuccess(state, action) {
      logger.log('getStyleSuccess : SUCCESS');

      state.loading = false;
      state.success = { type: action.type, message: 'Get Styles Success' };

      // state.styles = [...action.payload];
      state.styles = {
        ...state.styles,
        ...action.payload
      };

      //state.openIssuesCount = action.payload.open_issues_count
      state.error = null;
    },
    getStylesFailure(state, action) {
      logger.log(state, action, 'fail');
      state.error = action.payload;
    },


    //////////////////////
    //
    // SINGLE STYLE
    //
    //////////////////////
    getStyleStart(state, action) {
      state.success = null;
      state.error = null;
    },
    getStyleSuccess(state, action) {
      logger.log('getWipSuccess : SUCCESS');

      state.loading = false;
      state.success = { type: action.type, message: 'Get Wip Success', data: action.payload };
      // if(action.payload.urls){
      //   state.selectedProject = {...state.selectedProject, urls:action.payload.urls}
      // }
      state.selectedStyle = action.payload ? { ...action.payload } : null;
      //state.openIssuesCount = action.payload.open_issues_count
      state.error = null;
    },

    getWipAssetsSuccess(state, action) {
      logger.log('getWipSuccess : SUCCESS');

      state.loading = false;
      state.success = { type: action.type, message: 'Get Wips Assets Success' };

      state.selectedWip = { ...state.selectedWip, assets: action.payload };
      //state.openIssuesCount = action.payload.open_issues_count
      state.error = null;
    },

    getStyleFailure(state, action) {
      logger.log(state, action, 'fail');
      state.error = action.payload;
    },

    getWipScansSuccess(state, action) {
      logger.log('getWipScansSuccess : SUCCESS');

      state.loading = false;
      state.success = { type: action.type, message: 'Get Wip Scans Success' };

      state.selectedWip = { ...state.selectedWip, scans: action.payload };
      //state.openIssuesCount = action.payload.open_issues_count
      state.error = null;
    },

    getWipTimelineSuccess(state, action) {
      logger.log('getWipSuccess : SUCCESS');

      state.loading = false;
      state.success = { type: action.type, message: 'Get Wip Timeline Success' };

      if(state.selectedWip){
        state.selectedWip = {...state.selectedWip,timeline:action.payload.Timeline};
      }      
      //state.openIssuesCount = action.payload.open_issues_count
      state.error = null;
    },


    updateWipAssetSuccess(state, action) {
      logger.log('updateWipSuccess : SUCCESS');

      state.loading = false;
      state.success = { type: action.type, message: 'Update Wip Success' };
      // state.selectedWip = { ...action.payload };
      state.error = null;
    },
    udpateWipAssetFailure(state, action) {
      logger.log(state, action, 'fail');
      state.error = action.payload;
    },

    batchUpdateWipAssetSuccess(state, action) {
      state.loading = false;
      state.success = { type: action.type, message: 'Updated Wips Successfully' };
      // state.selectedWip = { ...action.payload };
      state.error = null;
    },

    distributeWipsSuccess(state, action) {
      logger.log('updateWipSuccess : SUCCESS');

      state.loading = false;
      state.success = { type: action.type, message: 'Update Wip Success' };

      // update the wips status for distributed items
      const tmpWips = [...state.wips].map(item => {
        const match = action.payload.find(id => id === item.id);
        if(match){
          return {...item, 
            // status:SampleStatusTypes.SAMPLE_DISTRIBUTED
          }
        }else{
          return item;
        }
       
      })

      state.wips = [...tmpWips];
      state.error = null;
    },
    distributeWipsFailure(state, action) {
      logger.log(state, action, 'fail');
      state.error = action.payload;
    },


    clearNotifications(state, action) {
      state.error = null;
      state.success = null;
    },

    onServiceStart(state, action) {
      state.success = null;
      state.loading = true;
      state.error = null;
      // state.action = action.type;
    },
    onServiceFailure(state, action) {
      logger.log(state, action, 'fail');
      state.error = action.payload;
      state.loading = false;
    },

  },
});


// STYLES
export const fetchStylesByUnit = (criteria) => async (dispatch) => {
  try {
      dispatch(getStylesStart());

      // const currentTime = Date.now();
      // if (state.styles.data && (currentTime - state.styles.timestamp) < 3600000) {
      //   // return cachedItem.data;
      // }

      const data = await styleService.getStylesByUnit(criteria);
      const result = new ResultSet(data,JSON.stringify(criteria),new Date())
      dispatch(getStylesSuccess(result));
  } catch (err) {
      logger.log('err', err);
      dispatch(getStylesFailure(err));
  }
};



export const fetchStyle = (id) => async (dispatch) => {
  try {
    dispatch(getStyleStart());
    // const data = await getStyleTimeline({ id: criteria.keyword });
    const data = await styleService.getStyle(id);
    dispatch(getStyleSuccess(data));
  } catch (err) {
    logger.log('err', err);
    dispatch(getStyleFailure(err));
  }
};



export const {
  // selectWip,
  selectStyles,
  setWipFilter,
  setStyleFilter,
  setDisplayPrefs,
  setListColumns,
  selectStyle,

  styleMediaFilter,
  setStyleMediaFilter,

  getWipStart,
  getWipFailure,
  getWipSuccess,


  getWipAssetsSuccess,

  getWipScansSuccess,

  getWipTimelineSuccess,

  getStylesStart,
  getStylesSuccess, 
  getStylesFailure,

  getStyleStart,
  getStyleSuccess,
  getStyleFailure,

  getWipsStart,
  getWipsFailure,
  getWipsSuccess,

  onServiceStart,
  onServiceFailure,

  updateWipAssetSuccess,
  updateWipAssetFailure,

  batchUpdateWipAssetSuccess,

  distributeWipsSuccess,
  distributeWipsFailure,

  clearNotifications,
  setError,
} = distributionSlice.actions;

export default distributionSlice.reducer;
